import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/settings"
  }, React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8889 5.66427L13.9371 7.14215C13.9784 7.4256 13.9994 7.71182 14 7.99863L13.9926 8.2879C13.9831 8.47869 13.9646 8.66888 13.9371 8.85785L15.8889 10.3357L13.9671 13.6643L11.7077 12.7111C11.2574 13.0674 10.7582 13.3571 10.2255 13.5713L9.92183 16H6.07816L5.77448 13.5713C5.24175 13.3571 4.74255 13.0674 4.29226 12.7111L2.03291 13.6643L0.111084 10.3357L2.06242 8.85821C1.97923 8.2891 1.97923 7.7109 2.06242 7.14179L0.111084 5.66427L2.03291 2.33567L4.29226 3.28886C4.74255 2.93262 5.24175 2.64294 5.77448 2.42874L6.07816 0H9.92183L10.2255 2.42874C10.7582 2.64294 11.2574 2.93262 11.7077 3.28886L13.9671 2.33567L15.8889 5.66427ZM11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Settings16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Settings16 = createIcon(IconComponent);